import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as CreativesActions from './creatives.actions';
import * as CreativesSelectors from './creatives.selector';

@Injectable({
    providedIn: 'root'
})
export class CreativesService {
    focusedElementId$ = this.store.select(CreativesSelectors.getFocusedElement);
    constructor(private store: Store) {}

    focusElement(elementId: string): void {
        this.store.dispatch(CreativesActions.focusElement({ elementId }));
    }

    blurElement(): void {
        this.store.dispatch(CreativesActions.blurElement());
    }
}
